import { render, staticRenderFns } from "./ButtonLoader.vue?vue&type=template&id=2bdb1ecc&scoped=true"
import script from "./ButtonLoader.vue?vue&type=script&lang=ts"
export * from "./ButtonLoader.vue?vue&type=script&lang=ts"
import style0 from "./ButtonLoader.vue?vue&type=style&index=0&id=2bdb1ecc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdb1ecc",
  null
  
)

export default component.exports